import { render, staticRenderFns } from "./previewRule.vue?vue&type=template&id=22f106ba&scoped=true&"
import script from "./previewRule.vue?vue&type=script&lang=js&"
export * from "./previewRule.vue?vue&type=script&lang=js&"
import style0 from "./previewRule.vue?vue&type=style&index=0&id=22f106ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f106ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22f106ba')) {
      api.createRecord('22f106ba', component.options)
    } else {
      api.reload('22f106ba', component.options)
    }
    module.hot.accept("./previewRule.vue?vue&type=template&id=22f106ba&scoped=true&", function () {
      api.rerender('22f106ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/previewRule.vue"
export default component.exports